<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header card-header-icon card-header-rose">
        <div class="card-icon">
          <i class="material-icons"></i>
        </div>
        <h4 class="card-title">Add new client</h4>
      </div>
      <div class="card-body">
        <div mat-dialog-content>
          <form name="userNewForm" #userNewForm="ngForm">
            <div *ngIf="data.company" class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="bmd-label-floating">Company Name</label>
                  <input
                    type="text"
                    class="form-control"
                    name="companyname"
                    #companyname="ngModel"
                    [(ngModel)]="companyName"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div *ngIf="!data.company" class="row">
              <div class="col-12">
                <app-filter-object
                  *ngIf="!buscandoCompanies"
                  [options]="companies"
                  [value]="companySelected"
                  (selectChange)="changeCompany($event)"
                  placeholder="Company Name"
                >
                </app-filter-object>
              </div>
            </div>
            <div *ngIf="!data.company" class="row">
              <div class="col-md-12">
                <button
                  (click)="openNuevoCompany()"
                  mat-raised-button
                  class="btn btn-success"
                >
                  <span class="btn-label">
                    <i class="material-icons">note_add</i>
                  </span>
                  New Company
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Title</label>
                  <input
                    type="text"
                    class="form-control"
                    name="ocupation"
                    #ocupation="ngModel"
                    [(ngModel)]="data.user.ocupation"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    name="name"
                    #name="ngModel"
                    [(ngModel)]="data.user.name"
                    required
                  />
                  <span *ngIf="!name.valid && name.touched">
                    ¡Name not valid!
                  </span>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    name="surname"
                    #surname="ngModel"
                    [(ngModel)]="data.user.surname"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">email</label>
                  <input
                    type="email"
                    class="form-control"
                    name="email"
                    #email="ngModel"
                    [(ngModel)]="data.user.email"
                  />
                  <label
                    *ngIf="email.touched && !validateEmail(data.user.email)"
                    style="color: red"
                    >The email is not valid</label
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Gender</label>
                  <select
                    name="gender"
                    #gender="ngModel"
                    [(ngModel)]="data.user.gender"
                    placeholder="Gender"
                    class="form-control"
                    required
                  >
                    <option value="" disabled>Please select a gender</option>
                    <option *ngFor="let sexo of sexos" [value]="sexo.value">
                      {{ sexo.viewValue }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <h4
                class="card-title"
                style="margin-left: 20px; margin-top: 40px"
              >
                Address Info -
                <small class="category">Address information</small>
              </h4>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Addresss </label>
                  <select
                    name="userlocation"
                    #userlocation="ngModel"
                    [(ngModel)]="data.user.locationId"
                    (change)="changeLocation()"
                    class="form-control fctrl"
                  >
                    <option [value]="null">Headquarter's Address</option>
                    <option
                      *ngFor="let loc of companyLocations"
                      [value]="loc.id"
                    >
                      {{ loc.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Address Line #</label>
                  <input
                    type="text"
                    class="form-control"
                    name="address"
                    #address="ngModel"
                    [(ngModel)]="data.user.address"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Address Line 2 #</label>
                  <input
                    type="text"
                    class="form-control"
                    name="address2"
                    #address2="ngModel"
                    [(ngModel)]="data.user.address2"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">City</label>
                  <input
                    type="text"
                    class="form-control"
                    name="city"
                    #city="ngModel"
                    [(ngModel)]="data.user.city"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">State</label>
                  <input
                    type="text"
                    class="form-control"
                    name="colonia"
                    #colonia="ngModel"
                    [(ngModel)]="data.user.colonia"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">Country</label>
                  <input
                    type="text"
                    class="form-control"
                    name="country"
                    #country="ngModel"
                    [(ngModel)]="data.user.country"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label class="bmd-label-floating">Zip Code</label>
                  <input
                    type="text"
                    class="form-control"
                    name="zipCode"
                    #zipCode="ngModel"
                    [(ngModel)]="data.user.zipCode"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-5">
                <div class="form-group">
                  <label class="bmd-label-floating">Work Phone</label>
                  <input
                    type="text"
                    class="form-control"
                    name="phone"
                    #phone="ngModel"
                    [(ngModel)]="data.user.phone"
                  />
                </div>
              </div>

              <div class="col-md-5">
                <div class="form-group">
                  <label class="bmd-label-floating">Mobile Phone</label>
                  <input
                    type="text"
                    class="form-control"
                    name="mobilePhone"
                    #mobilePhone="ngModel"
                    [(ngModel)]="data.user.mobilePhone"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <h4
                class="card-title"
                style="margin-left: 20px; margin-top: 40px"
              >
                Settings
              </h4>
            </div>
            <div class="row">
              <!-- <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating">Email Frequenc</label>
                    <select (change)="changeCompany()" id="companyform" name="frequency" #frequency="ngModel" [(ngModel)]="data.user.emailFrequency" placeholder="Email Frequenc" class="form-control"required>
                      <option value="" disabled>* Please select a company</option>
                      <option *ngFor="let frequency of frequencies" [value]="frequency.value">  {{ frequency.viewValue }}</option>
                    </select>
                  </div>
                </div> -->

              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Customer Type</label>
                  <select
                    id="customerType"
                    name="customerType"
                    #customerType="ngModel"
                    [(ngModel)]="data.user.customerType"
                    placeholder="Customer Type"
                    class="form-control"
                    required
                  >
                    <option value="" disabled>* Please select a type</option>
                    <option value="End User">End User</option>
                    <option value="Wholesaler">Wholesaler</option>
                    <option value="Broker">Broker</option>
                    <option value="Reseller">Reseller</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <h4
                class="card-title"
                style="margin-left: 20px; margin-top: 40px"
              >
                Categories
              </h4>
              <br />
            </div>

            <div class="row">
              <div class="col-3" *ngFor="let item of categories">
                <div class="row">
                  <mat-checkbox
                    [name]="item.name"
                    (change)="addCategoire(item, $event)"
                    [checked]="isCheked(item)"
                    >{{ item.name }}</mat-checkbox
                  >
                </div>
                <div *ngIf="isAdded(item.id)">
                  <div class="row" *ngIf="item.sub.length > 1">
                    &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                    <mat-checkbox
                      [name]="item.id"
                      (change)="
                        addCategoire(
                          { id: item.id, father: item.id, name: 'All' },
                          $event
                        )
                      "
                      [checked]="checkedAll(item.id)"
                      >All</mat-checkbox
                    >
                  </div>
                  <div class="row" *ngFor="let i of item.sub">
                    &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                    <mat-checkbox
                      [name]="i.name"
                      (change)="addCategoire(i, $event)"
                      [checked]="isCheked(i)"
                      >{{ i.name }}</mat-checkbox
                    >
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <div class="row">
              <h4
                class="card-title"
                style="margin-left: 20px; margin-top: 40px"
              >
                Ranking
              </h4>
            </div>

            <div class="row">
              <div class="col-md-3">
                <label>Pricing: </label> <br />
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerPricing = 1"
                    [ngClass]="{
                      'fa-star': data.user.customerPricing >= 1,
                      'fa-star-o': data.user.customerPricing < 1
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerPricing = 2"
                    [ngClass]="{
                      'fa-star': data.user.customerPricing >= 2,
                      'fa-star-o': data.user.customerPricing < 2
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerPricing = 3"
                    [ngClass]="{
                      'fa-star': data.user.customerPricing >= 3,
                      'fa-star-o': data.user.customerPricing < 3
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerPricing = 4"
                    [ngClass]="{
                      'fa-star': data.user.customerPricing >= 4,
                      'fa-star-o': data.user.customerPricing < 4
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerPricing = 5"
                    [ngClass]="{
                      'fa-star': data.user.customerPricing >= 5,
                      'fa-star-o': data.user.customerPricing < 5
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
              </div>
              <div class="col-md-3">
                <label>Response Time: </label> <br />
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerResponseTime = 1"
                    [ngClass]="{
                      'fa-star': data.user.customerResponseTime >= 1,
                      'fa-star-o': data.user.customerResponseTime < 1
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerResponseTime = 2"
                    [ngClass]="{
                      'fa-star': data.user.customerResponseTime >= 2,
                      'fa-star-o': data.user.customerResponseTime < 2
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerResponseTime = 3"
                    [ngClass]="{
                      'fa-star': data.user.customerResponseTime >= 3,
                      'fa-star-o': data.user.customerResponseTime < 3
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerResponseTime = 4"
                    [ngClass]="{
                      'fa-star': data.user.customerResponseTime >= 4,
                      'fa-star-o': data.user.customerResponseTime < 4
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerResponseTime = 5"
                    [ngClass]="{
                      'fa-star': data.user.customerResponseTime >= 5,
                      'fa-star-o': data.user.customerResponseTime < 5
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
              </div>
              <div class="col-md-3">
                <label>Payment on Time: </label> <br />
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerPaymentOnTime = 1"
                    [ngClass]="{
                      'fa-star': data.user.customerPaymentOnTime >= 1,
                      'fa-star-o': data.user.customerPaymentOnTime < 1
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerPaymentOnTime = 2"
                    [ngClass]="{
                      'fa-star': data.user.customerPaymentOnTime >= 2,
                      'fa-star-o': data.user.customerPaymentOnTime < 2
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerPaymentOnTime = 3"
                    [ngClass]="{
                      'fa-star': data.user.customerPaymentOnTime >= 3,
                      'fa-star-o': data.user.customerPaymentOnTime < 3
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerPaymentOnTime = 4"
                    [ngClass]="{
                      'fa-star': data.user.customerPaymentOnTime >= 4,
                      'fa-star-o': data.user.customerPaymentOnTime < 4
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerPaymentOnTime = 5"
                    [ngClass]="{
                      'fa-star': data.user.customerPaymentOnTime >= 5,
                      'fa-star-o': data.user.customerPaymentOnTime < 5
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
              </div>
              <div class="col-md-3">
                <label>Easy to work with: </label> <br />
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerEasyToWorkWith = 1"
                    [ngClass]="{
                      'fa-star': data.user.customerEasyToWorkWith >= 1,
                      'fa-star-o': data.user.customerEasyToWorkWith < 1
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerEasyToWorkWith = 2"
                    [ngClass]="{
                      'fa-star': data.user.customerEasyToWorkWith >= 2,
                      'fa-star-o': data.user.customerEasyToWorkWith < 2
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerEasyToWorkWith = 3"
                    [ngClass]="{
                      'fa-star': data.user.customerEasyToWorkWith >= 3,
                      'fa-star-o': data.user.customerEasyToWorkWith < 3
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerEasyToWorkWith = 4"
                    [ngClass]="{
                      'fa-star': data.user.customerEasyToWorkWith >= 4,
                      'fa-star-o': data.user.customerEasyToWorkWith < 4
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
                <a class="rank btn-just-icon">
                  <i
                    class="fa"
                    (click)="data.user.customerEasyToWorkWith = 5"
                    [ngClass]="{
                      'fa-star': data.user.customerEasyToWorkWith >= 5,
                      'fa-star-o': data.user.customerEasyToWorkWith < 5
                    }"
                    aria-hidden="true"
                  ></i>
                </a>
              </div>
            </div>
            <div mat-dialog-actions>
              <button
                mat-button
                [disabled]="
                  !validateEmail(data.user.email) ||
                  data.user.surname == '' ||
                  data.user.name == ''
                "
                class="btn btn-success"
                cdkFocusInitial
                (click)="closeModal()"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="col-md-4">
    <div class="card">
      <div class="card-header card-header-icon card-header-rose">
        <div class="card-icon">
          <i class="material-icons"></i>
        </div>
        <h4 class="card-title">Password</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating">Password</label>
              <input type="text" name="password" #password="ngModel" [(ngModel)]="data.user.password" required  class="form-control">
            </div>
          </div>
        </div>
      </div>
     </div>
    </div> -->
</div>
